import { Box, Grid, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerError: {
      backgroundColor: '#ffefee',
      color: '#ff574d',
      padding: theme.spacing(2),
    },
    upperHeaderText: {
      fontSize: 10,
      letterSpacing: 1.5,
      fontWeight: 500,
    },
    mainHeaderText: {
      fontWeight: 500,
    },
    body: {
      padding: theme.spacing(2),
    },
  }),
);

const MissingRefundPolicy: React.FC = () => {
  const classes = useStyles();
  return (
    <Box>
      <Grid container className={classes.headerError}>
        <Grid item xs={12} lg={12}>
          <Typography variant="body2" className={classes.upperHeaderText}>
            NO REFUND POLICY FOUND
          </Typography>
        </Grid>
        <Grid item xs={12} lg={12}>
          <Typography className={classes.mainHeaderText}>Payment sender has no refund policy set.</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.body}>
        <Grid item xs={12} lg={12}>
          <Typography variant="body2">A refund policy is required for the merchant in order to properly receive payments.</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MissingRefundPolicy;
